export default "__VITE_ASSET__BAk0Pmbj__"